import { render, staticRenderFns } from "./CustomerProjectsModal.vue?vue&type=template&id=87133c3e&"
import script from "./CustomerProjectsModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerProjectsModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerProjectsModal.vue?vue&type=style&index=0&id=87133c3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports